import { Grid, Typography } from '@mui/material';
import atab_logo from '../../../../../../assets/image/atab-logo.png';
import { Box } from '@mui/system';
import dayjs from 'dayjs';
const PrintHeadingOfLogo = () => {
  return (
    <Grid container>
      <Grid item xs={3}>
        {' '}
        <img
          src={`${atab_logo}`}
          alt='Atab Logo'
          loading='lazy'
          height='50px'
        />
      </Grid>
      <Grid item xs={7}>
        {' '}
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontSize: '15px', fontWeight: 'bold' }}>
            ATAB Head Office
          </Typography>
          <Typography sx={{ fontSize: '11px' }}>
            Sattara Center (15th Floor), 30/A Naya Paltan, VIP Road, Dhaka-1000.
          </Typography>
          <Typography sx={{ fontSize: '11px' }}>
            Tel: +880 2 48320728, 8332712, Email: atab@atab.org.bd,
            www.atab.org.bd
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={2}>
        <p
          style={{
            fontSize: '10px',
            marginTop: '41px',
          }}
        >
          Printed on : {dayjs().format('DD/MM/YYYY')}
        </p>
      </Grid>
    </Grid>
  );
};

export default PrintHeadingOfLogo;
